import {Injectable} from "@angular/core";
import {UrlsResources} from "../urls-resources";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {PromocionInfo} from "./promocion-info";
import {AuthService} from "../auth/auth.service";
import {HandleError} from '../handle-error';
import {DetailPromotionRequest} from "../../components/promociones/quantum/detail-promotion/detail-promotion-request";

@Injectable()
export class PromocionesService {
  constructor(protected httpClient: HttpClient,
              private authService: AuthService,
              private handleError: HandleError,
              protected urlsResources: UrlsResources) {
  }

  getPromociones(promotionType: string): Observable<PromocionInfo[]> {
    return this.httpClient.get<PromocionInfo[]>(this.urlsResources.getPromociones(promotionType), {withCredentials: true});
  }

  disablePromotion(promocion: PromocionInfo): Observable<void> {
    return this.httpClient.post<void>(this.urlsResources.getPromocionesChangeStatus(), {
      promotionKey: promocion.promotionKey,
      active: !promocion.active
    }, {withCredentials: true});
  }

  downloadErrorCodes(promotionKey: string): Observable<Blob> {
    return this.httpClient.get(this.urlsResources.getErrorCodesCsv(promotionKey), {
      withCredentials: true,
      responseType: "blob"
    });
  }

  savePromotion(model: any): Observable<any> {
    const httpOptions = {
      withCredentials: true
    };
    return new Observable(observer => {
      console.log('token', this.authService.getToken());
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      const url = this.urlsResources.persistPromotion();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 201) {
            observer.next(xhr);
            observer.complete();
          } else if (xhr.status === 400) {
            observer.error(xhr.responseText);
          } else {
            console.log(xhr);
            observer.error(JSON.parse(xhr.responseText));
            // data = new FormData();
          }
        }
      };
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.authService.getToken());
      xhr.send(model);
    });

  }

  getDefaultPromotion(): Observable<any> {
    return this.httpClient.get(this.urlsResources.getDefaultPromotion(), {withCredentials: true});
  }

  getPromotionTypeList(isGanalottodo: boolean): Observable<any> {
    return this.httpClient.get(this.urlsResources.getPromotionTypeList(isGanalottodo), {withCredentials: true});
  }

  getPromotionByKey(key: string): Observable<any> {
    return this.httpClient.get(this.urlsResources.getPromotionByKey(key), {withCredentials: true});
  }

  getAdminUsernames() {
    return this.httpClient.get(this.urlsResources.getAdminUsernames(), {withCredentials: true})
      .map(response => response)
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error);
      });
  }

  patchPromotion(promotion: any, key: string): Observable<any> {

    return new Observable(observer => {
      console.log('token', this.authService.getToken());
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      const url = this.urlsResources.persistPromotion() + '/' + key;
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 201) {
            observer.next(xhr);
            observer.complete();
          } else {
            console.log(xhr);
            observer.error(JSON.parse(xhr.responseText));
            //data = new FormData();
          }
        }
      };
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.authService.getToken());
      xhr.send(promotion);
    });
    /* return this.httpClient.patch(this.urlsResources.persistPromotion(), JSON.stringify(promotion))
      .map(response => response)
      .catch(err => this.handleError.handleErrorAsObservable(err)); */
  }

  changePrincipal(promocion: PromocionInfo) {
    return this.httpClient.post<void>(this.urlsResources.getPromocionesChangePrincipal(), {
      promotionKey: promocion.promotionKey,
      active: !promocion.defaultPromotion
    }, {withCredentials: true});
  }

  uploadCodesPromotion(formData): Observable<any> {
    console.log('PromocionesService#uploadCodesPromotion:file');
    console.log(formData.get);
    const headers = new HttpHeaders();
    headers.set('Accept', 'multipart/form-data');
    headers.set('Content-Type', 'multipart/form-data');
    return this.httpClient.post(this.urlsResources.uploadCodesPromotions(), formData, {withCredentials: true});
  }

  generateAndAddCodes(addCodesRequest): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.httpClient.post(this.urlsResources.generateAndAddCodesPromotionsUrl(), addCodesRequest, {withCredentials: true});

  }

  getDetailPromotion(detailPromotionRequest: DetailPromotionRequest): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('status', detailPromotionRequest.status.toString());
    params = params.set('page', detailPromotionRequest.page.toString());
    params = params.set('pageSize', detailPromotionRequest.pageSize.toString());
    if (detailPromotionRequest.username) {
      params = params.set('username', detailPromotionRequest.username);
    }
    const options = {params: params, withCredentials: true};
    return this.httpClient.get(this.urlsResources.getPromotionDetail(detailPromotionRequest.promotionKey), options);
  }

  resendEmailPromotion(promotionIds: string[]): Observable<void> {
    const options = {withCredentials: true};
    return this.httpClient.post<void>(this.urlsResources.resendEmailPromotionUrl(), promotionIds, options);
  }

  retryPromotion(promotionIds: string[]): Observable<Array<String>> {
    const options = {withCredentials: true};
    return this.httpClient.post<Array<String>>(this.urlsResources.retryPromotionUrl(), promotionIds, options);
  }

  getPromotionTriggers(): Observable<Array<any>> {
    const options = {withCredentials: true};
    return this.httpClient.get<Array<any>>(this.urlsResources.promotionTriggers(), options);
  }

  getGamesForPromotion(): Observable<any> {
    const options = {withCredentials: true};
    return this.httpClient.get<any>(this.urlsResources.getGamesForPromotionUrl(), options);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/promociones/promociones.service.ts